'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".locked__user--container {\n  padding: 15px;\n  border: 1px solid #F44336;\n  border-radius: 5px;\n  background-color: #FFEBEE;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n}\n.locked__user--container p {\n  margin: 0 15px 8px;\n  line-height: 20px;\n  font-weight: 400;\n}\n.locked__user--container .icon {\n  width: 24px;\n  height: 24px;\n}");
//# sourceMappingURL=LockedUserMessage.scss.js.map
